import RequestForm from "./RequestForm";
import { isElectron } from "./api";
import Dashboard from "./Dashboard";
import CleoForm from "./RequestForm/CleoForm";

function App() {
  const isDashboard =
    isElectron() || location.pathname.startsWith("/dashboard");
  if (isDashboard) return <Dashboard />;
  else if (location.pathname.startsWith("/cleo")) return <CleoForm />;
  else return <RequestForm />;
}

export default App;
